// extracted by mini-css-extract-plugin
export default {"button":"weButton_button__Qg7g8","hover":"weButton_hover__1xX34","outline":"weButton_outline__g-4AY"};